export default __webpack_public_path__ + "src/assets/arrow-right.91e39cffd3d7cfe32711b8a454fe20c5.svg";